import googleIcon from './assets/google-icon.svg';

export function GoogleIcon() {
  return <img src={googleIcon} alt="" aria-hidden className="size-5" />;
}
